import axios from 'axios';

// API base URL - development için localhost, production için aynı domain
const baseURL = process.env.NODE_ENV === 'production' 
  ? '' // Production'da aynı domain kullan
  : 'http://localhost:8000';

const api = axios.create({
  baseURL: baseURL,
  timeout: 30000,
  headers: {
    'Content-Type': 'application/json',
    'Cache-Control': 'no-cache',
    'Pragma': 'no-cache'
  },
});

// Request interceptor - her istekte token ekle
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor - 401 durumunda logout yap
api.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (error.response?.status === 401) {
      // Token geçersiz - sadece localStorage'ı temizle
      // Sayfa yenileme durumunda mevcut sayfada kalmak için yönlendirme yapmıyoruz
      localStorage.clear();
      
      // Sadece login sayfasında değilsek yönlendir
      if (!window.location.pathname.includes('/login')) {
        // React Router ile yönlendirme yapmak için event dispatch et
        window.dispatchEvent(new CustomEvent('auth-logout'));
      }
    }
    return Promise.reject(error);
  }
);

export default api;
